export default __webpack_public_path__ + "static/media/Vitae_Home.7ac163c0.png";